import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCreditCard2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"credit-card-2, card, payment"} maskId="square-filled-radius-0-stroke-1-IconCreditCard2"><path d="M22 4H2V9.5H22V4Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M2 20V10.5H22V20H2ZM6 13V14H10V13H6Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCreditCard2;
